import { Checkbox, FormControlLabel, } from "@mui/material";
import Grid from '@mui/material/Grid';
import { PhotoEvent } from 'common-models';
import { FC } from "react";

interface EventOptionsProps {
    photoEvent: PhotoEvent
    setIsPublic: (value: boolean) => void
    setIsExternalCopyright: (value: boolean) => void
    setIsFreeOfCharge: (value: boolean) => void
    setDisplayFreeOfChargeText: (value: boolean) => void
}

const EventOptions: FC<EventOptionsProps> = (props: EventOptionsProps) => {

    const onIsPublicChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event !== undefined) {
            props.setIsPublic(event.target.checked);
        }
    }

    const onIsExternalCopyrightChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event !== undefined) {
            props.setIsExternalCopyright(event.target.checked);
        }
    }

    const onDisplayFreeOfChargeTextChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event !== undefined) {
            props.setDisplayFreeOfChargeText(event.target.checked);
        }
    }


    const onIsFreeOfChargeChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event !== undefined) {

            props.setIsFreeOfCharge(event.target.checked)
        }
    }


    return (
        <>
            <Grid container>
                <FormControlLabel
                    control={
                        <Checkbox id='event-ispublic' onChange={onIsPublicChanged} defaultChecked={props.photoEvent.isPublic} />
                    }
                    label='Event is public' />
            </Grid>

            <Grid container>
                <FormControlLabel
                    control={
                        <Checkbox id='event-isexternalcopyright' onChange={onIsExternalCopyrightChanged} defaultChecked={props.photoEvent.isExternalCopyright} />
                    }
                    label='Do not put copyright on web images' />
            </Grid>

            <Grid container>
                <FormControlLabel
                    control={
                        <Checkbox id='event-isfreeofcharge' onChange={onIsFreeOfChargeChanged} defaultChecked={props.photoEvent.isFreeOfCharge} />
                    }
                    label='Event photos are free of charge' />
            </Grid>

            <Grid container>
                <FormControlLabel
                    control={
                        <Checkbox id='event-displayfreeofchargetext' onChange={onDisplayFreeOfChargeTextChanged} defaultChecked={props.photoEvent.displayFreeOfChargeText} />
                    }
                    label='Display Free-of-charge text' />
            </Grid>

        </>
    )
}

export default EventOptions;
